import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'VISIT_DASHBOARD_LIST';

export default createListReducer(TEMPLATE_NAME);
